/**
 * This build's Clerk satellite configuration (ADR-0091).
 *
 * Read once, here, so `main.tsx` (which spreads the props onto
 * `<ClerkProvider>`) and the sign-in surface (which must link out to the
 * primary domain instead of rendering `<SignIn/>`) can never disagree about
 * whether this build is a satellite.
 */

// Imported from the dedicated subpath, not the package barrel: the barrel
// pulls in node-only modules that a browser-only SPA must not typecheck
// against.
import { clerkSatelliteProps, isClerkSatellite } from '@regta/common/clerk-satellite';

export const clerkSatellite = clerkSatelliteProps({
  proxyUrl: import.meta.env['VITE_CLERK_PROXY_URL'] as string | undefined,
  signInUrl: import.meta.env['VITE_CLERK_SIGN_IN_URL'] as string | undefined,
  signUpUrl: import.meta.env['VITE_CLERK_SIGN_UP_URL'] as string | undefined,
});

/**
 * True when sign-in must happen on the primary domain. Clerk forbids a
 * satellite from hosting the sign-in or sign-up flow.
 */
export const signInOnPrimary = isClerkSatellite(clerkSatellite);

/** This build's proxy URL, when it's a satellite — undefined otherwise. */
export const clerkProxyUrl =
  'isSatellite' in clerkSatellite ? clerkSatellite.proxyUrl : undefined;
